import { useCallback } from "react";

/**
 * Indicators starred (☆) in the indicators menu, kept in the chart settings.
 *
 * @param {{ settings: object, updateSettings: Function }} chartSettingsApi - useChartSettings
 * @returns {{ favoriteIds: string[], toggleFavorite: (id: string) => void }}
 */
const useFavoriteIndicators = ({ settings, updateSettings }) => {
  const favoriteIds = settings.favoriteIndicators;

  const toggleFavorite = useCallback(
    (id) => {
      const isFavorite = favoriteIds.includes(id);

      updateSettings({
        favoriteIndicators: isFavorite
          ? favoriteIds.filter((favoriteId) => favoriteId !== id)
          : [...favoriteIds, id],
      });
    },
    [favoriteIds, updateSettings],
  );

  return { favoriteIds, toggleFavorite };
};

export default useFavoriteIndicators;
